/** demo — EN source. */
export const demo = {
  // App shell / header
  demo_app_title: "Demo Mini App",
  demo_status_connected: "Connected",
  demo_status_disconnected: "Disconnected",
  demo_config_version: "{name} v{version}",

  // Console
  demo_console_title: "Console",
  demo_console_clear: "Clear",
  demo_console_empty: "No logs yet...",

  // Bridge lifecycle logs
  demo_bridge_initializing: "Initializing bridge...",
  demo_bridge_connected: "Bridge connected!",
  demo_bridge_config_loaded: "Config loaded: {name} v{version}",
  demo_bridge_config_failed: "Failed to get config: {error}",
  demo_bridge_user_loaded: "User loaded: {userId}",
  demo_bridge_user_failed: "Failed to get user: {error}",
  demo_bridge_user_updated: "User updated",
  demo_bridge_init_failed: "Bridge init failed: {error}",
  demo_bridge_logs_cleared: "Logs cleared",

  // User section
  demo_user_title: "User Context",
  demo_user_result_placeholder: "Click a button to see results...",
  demo_user_get_info: "Get User Info",
  demo_user_get_token: "Get Auth Token",
  demo_user_log_get_info: "Calling user.getInfo()...",
  demo_user_log_info_retrieved: "User info retrieved",
  demo_user_log_get_info_error: "getUserInfo error: {error}",
  demo_user_log_get_token: "Calling user.getAuthToken()...",
  demo_user_log_token_retrieved: "Auth token retrieved",
  demo_user_log_get_token_error: "getAuthToken error: {error}",

  // Modal section
  demo_modal_title: "Modal Control",
  demo_modal_default_title: "Custom Title",
  demo_modal_title_placeholder: "Enter title...",
  demo_modal_set_title: "Set Title",
  demo_modal_full_height: "Full Height",
  demo_modal_half_height: "Half Height",
  demo_modal_close: "Close Modal",
  demo_modal_close_message: "Closed from demo",
  demo_modal_log_set_title: 'Setting modal title: "{title}"...',
  demo_modal_log_title_set: "Title set",
  demo_modal_log_set_title_error: "setModalTitle error: {error}",
  demo_modal_log_set_full: "Setting height: full...",
  demo_modal_log_full_set: "Height set to full",
  demo_modal_log_set_half: "Setting height: half...",
  demo_modal_log_half_set: "Height set to half",
  demo_modal_log_set_height_error: "setModalHeight error: {error}",
  demo_modal_log_closing: "Closing modal...",
  demo_modal_log_close_error: "closeModal error: {error}",

  // Toast & Alerts section
  demo_toast_title: "Toast & Alerts",
  demo_toast_success: "Success",
  demo_toast_error: "Error",
  demo_toast_warning: "Warning",
  demo_toast_info: "Info",
  demo_toast_alert: "Alert",
  demo_toast_destructive: "Destructive",
  demo_toast_message_success: "Operation successful!",
  demo_toast_message_error: "Something went wrong!",
  demo_toast_message_warning: "Please be careful!",
  demo_toast_message_info: "Here is some information.",
  demo_toast_log_showing: "Showing {type} toast...",
  demo_toast_log_shown: "Toast shown",
  demo_toast_log_show_error: "showToast error: {error}",
  demo_alert_title: "Demo Alert",
  demo_alert_message: "Are you sure you want to proceed with this action?",
  demo_alert_confirm: "Confirm",
  demo_alert_cancel: "Cancel",
  demo_alert_log_showing: "Showing alert dialog...",
  demo_alert_log_result_confirmed: "Alert result: Confirmed",
  demo_alert_log_result_cancelled: "Alert result: Cancelled",
  demo_alert_log_error: "showAlert error: {error}",
  demo_alert_destructive_title: "Delete Item",
  demo_alert_destructive_message: "This action cannot be undone. Are you sure?",
  demo_alert_destructive_confirm: "Delete",
  demo_alert_destructive_log_showing: "Showing destructive alert...",
  demo_alert_destructive_log_result_deleted:
    "Destructive alert result: Deleted",
  demo_alert_destructive_log_result_cancelled:
    "Destructive alert result: Cancelled",
  demo_alert_destructive_log_error: "showDestructiveAlert error: {error}",

  // Storage section
  demo_storage_title: "Storage",
  demo_storage_result_placeholder: "Storage results will appear here...",
  demo_storage_default_value: "Hello from Mini App!",
  demo_storage_key_placeholder: "Enter key...",
  demo_storage_value_placeholder: "Enter value...",
  demo_storage_set: "Set",
  demo_storage_get: "Get",
  demo_storage_remove: "Remove",
  demo_storage_log_setting: "Setting storage: {key} = {value}...",
  demo_storage_log_set: "Storage item set",
  demo_storage_log_set_error: "setStorageItem error: {error}",
  demo_storage_log_getting: "Getting storage: {key}...",
  demo_storage_log_retrieved: "Storage item retrieved",
  demo_storage_log_get_error: "getStorageItem error: {error}",
  demo_storage_log_removing: "Removing storage: {key}...",
  demo_storage_log_removed: "Storage item removed",
  demo_storage_log_remove_error: "removeStorageItem error: {error}",

  // API section
  demo_api_title: "API Proxy",
  demo_api_result_placeholder: "API results will appear here...",
  demo_api_call: "Make API Call",
  demo_api_log_calling: "API: {method} {endpoint}...",
  demo_api_log_success: "API call successful ({status})",
  demo_api_log_error: "apiCall error: {error}",

  // Permissions section
  demo_permissions_title: "Permissions",
  demo_permissions_result_placeholder: "Permission results will appear here...",
  demo_permissions_request_camera: "Request Camera",
  demo_permissions_request_files: "Request Files",
  demo_permissions_request_location: "Request Location",
  demo_permissions_request_notifs: "Request Notifs",
  demo_permissions_check_camera: "Check Camera",
  demo_permissions_get_all: "Get All",
  demo_permissions_log_requesting: "Requesting permission: {permission}...",
  demo_permissions_log_granted: "Permission granted",
  demo_permissions_log_denied: "Permission denied",
  demo_permissions_log_request_error: "requestPermission error: {error}",
  demo_permissions_log_checking: "Checking permission: {permission}...",
  demo_permissions_log_check_granted: "Permission {permission}: granted",
  demo_permissions_log_check_not_granted:
    "Permission {permission}: not granted",
  demo_permissions_log_check_error: "hasPermission error: {error}",
  demo_permissions_log_getting_all: "Getting all permissions...",
  demo_permissions_log_got_all: "Got {count} permissions",
  demo_permissions_log_get_all_error: "getPermissions error: {error}",

  // Haptics section
  demo_haptics_title: "Haptics",
  demo_haptics_light: "Light",
  demo_haptics_medium: "Medium",
  demo_haptics_heavy: "Heavy",
  demo_haptics_success: "Success",
  demo_haptics_error: "Error",
  demo_haptics_warning: "Warning",
  demo_haptics_log_triggering: "Triggering haptic: {type}...",
  demo_haptics_log_triggered: "Haptic triggered",
  demo_haptics_log_error: "triggerHaptic error: {error}",
};
